export const DESKTOP_AUTH_STORAGE_KEY = "1t.desktopAuth";

const base64Url = (bytes: Uint8Array): string => {
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};

export type DesktopAuthRequest = {
  challenge: string;
  state: string;
  verifier: string;
};

export const createDesktopAuthRequest = async (): Promise<DesktopAuthRequest> => {
  const verifier = base64Url(crypto.getRandomValues(new Uint8Array(32)));
  const state = base64Url(crypto.getRandomValues(new Uint8Array(24)));
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return { verifier, state, challenge: base64Url(new Uint8Array(digest)) };
};

export const parseDesktopAuthReturn = (
  query: string,
): { code: string; state: string } | undefined => {
  const params = new URLSearchParams(query.startsWith("?") ? query.slice(1) : query);
  const code = params.get("code");
  const state = params.get("state");
  if (!code || code.length > 4096 || !state || !/^[A-Za-z0-9_-]{20,128}$/.test(state)) return undefined;
  return { code, state };
};
